module.exports = "/shared/img/button-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/button-down.png
// module id = 433
// module chunks = 13